import { Variants } from 'framer-motion';
import { BATTLE_TIMINGS, BATTLE_VALUES } from '../../constants/battleTimings';

export const screenVariants: Variants = {
  idle: {
    filter: 'brightness(1)',
    x: 0,
    y: 0,
  },
  meterOverdrive: {
    filter: ['brightness(1)', 'brightness(1.3)', 'brightness(1)'],
    x: [0, -5, 5, -5, 5, 0],
    y: [0, -3, 3, -3, 3, 0],
    transition: {
      filter: { duration: BATTLE_TIMINGS.TRANSITIONS.METER_FLASH_DURATION },
      x: { duration: BATTLE_TIMINGS.TRANSITIONS.SCREEN_SHAKE_X_DURATION },
      y: { duration: BATTLE_TIMINGS.TRANSITIONS.SCREEN_SHAKE_Y_DURATION },
    },
  },
};

export const tokenCardVariants: Variants = {
  idle: {
    scale: 1,
    opacity: 1,
    filter: 'brightness(1) contrast(1) saturate(1)',
  },
  elimination: {
    scale: [1, 1.1, 1],
    filter: [
      'brightness(1) contrast(1) saturate(1)',
      'brightness(1.5) contrast(1.2) saturate(0.8)',
      'brightness(0.9) contrast(1) saturate(0.5)',
    ],
    transition: { duration: 0.8 },
  },
  draining: {
    scale: [1, 0.95, 0.9],
    opacity: 1,
    filter: 'brightness(0.8) contrast(0.9) saturate(0.2) grayscale(0.5)',
    transition: { duration: 1.5 },
  },
  dead: {
    scale: 0.9,
    opacity: 0.4,
    filter: 'brightness(0.5) contrast(0.7) saturate(0) grayscale(1)',
    transition: { duration: 0.3 },
  },
  winner: {
    scale: [1, 1.05, 1],
    transition: { duration: 0.5, repeat: 3 },
  },
};

export const tokenAvatarVariants: Variants = {
  idle: {
    rotate: 0,
    scale: 1,
  },
  eliminationLeft: {
    rotate: [0, -5, 5, -5, 5, 0],
    transition: { duration: 0.8 },
  },
  eliminationRight: {
    rotate: [0, -5, 5, -5, 5, 0],
    transition: { duration: 0.8 },
  },
  winnerLeft: {
    scale: [1, 1.05, 1],
    transition: { duration: 1, repeat: 3 },
  },
  winnerRight: {
    scale: [1, 1.05, 1],
    transition: { duration: 1, repeat: 3 },
  },
  draining: {
    scale: [1, 0.95, 0.9],
    transition: { duration: 1.5 },
  },
  dead: {
    scale: 0.9,
  },
};

export const shockwaveVariants: Variants = {
  initial: { scale: 0, opacity: 1 },
  animate: {
    scale: [0, 3, 4],
    opacity: [1, 0.5, 0],
    borderWidth: ['2px', '4px', '1px'],
    transition: { duration: 0.8, ease: 'easeOut' },
  },
};

export const eliminationFlashVariants: Variants = {
  initial: { opacity: 0 },
  flash: {
    opacity: [0, 0.8, 0],
    transition: { duration: 0.3, delay: 0.5 },
  },
};

export const coinVariants: Variants = {
  initial: {
    x: 0,
    y: 0,
    opacity: 0,
    scale: 0,
    rotate: 0,
  },
  animate: (custom: { endX: number; endY: number; startX: number; startY: number; size: string; delay: number }) => {
    const midX = (custom.endX - custom.startX) / 2;
    const midY = (custom.endY - custom.startY) / 2 - BATTLE_VALUES.COINS.ARC_HEIGHT;
    
    return {
      x: custom.endX - custom.startX,
      y: [0, midY, custom.endY - custom.startY],
      opacity: [0, 1, 1, 0],
      scale: [0, 1.2, 1, 0.3],
      rotate: [0, 180, 360],
      transition: {
        duration: BATTLE_TIMINGS.COINS.ANIMATION_DURATION_BASE + 
          (custom.size === 'large' ? BATTLE_TIMINGS.COINS.ANIMATION_DURATION_LARGE_BONUS : 0),
        delay: custom.delay,
        ease: [0.4, 0, 0.2, 1],
        rotate: { duration: BATTLE_TIMINGS.COINS.ROTATION_DURATION, ease: 'linear' },
      },
    };
  },
  exit: { opacity: 0 },
};

export const floatingTextVariants: Variants = {
  initial: { x: '-50%', y: 0, opacity: 0, scale: 0 },
  animate: {
    x: '-50%',
    y: -50,
    opacity: [0, 1, 1, 0],
    scale: [0, 1.5, 1.5, 1],
    transition: { duration: BATTLE_TIMINGS.VICTORY.FLOATING_TEXT_DURATION / 1000, ease: 'easeOut' },
  },
  exit: { opacity: 0 },
};

export const particleVariants: Variants = {
  initial: { x: 0, y: 0, opacity: 1, scale: 0 },
  animate: (custom: { angle: number; distance: number; delay: number }) => ({
    x: Math.cos(custom.angle) * custom.distance,
    y: Math.sin(custom.angle) * custom.distance,
    opacity: [0, 1, 0],
    scale: [0, 1.5, 0],
    transition: {
      duration: 0.8,
      delay: custom.delay,
      ease: 'easeOut',
    },
  }),
};